import { useEffect, useState, useRef } from 'react';

/**
 * Anima un numero da 0 al target quando `active` diventa true.
 * Con `once: true` l'animazione parte una sola volta e il valore non si resetta.
 */
const useCountUp = (target, { duration = 1000, active = false, once = false } = {}) => {
  const [value, setValue] = useState(0);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!active) {
      if (!once) setValue(0);
      return undefined;
    }

    if (once && hasAnimated.current) return undefined;

    let frameId;
    const start = performance.now();
    hasAnimated.current = true;

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      setValue(Math.round(eased * target));
      if (progress < 1) frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [target, duration, active, once]);

  return value;
};

export default useCountUp;
